// extracted by mini-css-extract-plugin
module.exports = {"vertical":"style__vertical__FhtKr"};